var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container page-top"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "container has-text-centered opaque",
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin fa-4x"
  }), _vm._v(" "), _c('p', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-three-quarters"
  }, [_c('span', {
    staticClass: "title is-5"
  }, [_vm._v("Manage Associations")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-link mobile-button",
    attrs: {
      "to": "/associations/new"
    }
  }, [_vm._v("New")])], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-one-quarter hide-mobile"
  }, [_c('div', {
    staticClass: "field list-buttons"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "button is-link",
    attrs: {
      "to": "/associations/new"
    }
  }, [_vm._v("Create Association")])], 1)])])]) : _vm._e()]), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "container"
  }, [_c('hr'), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-three-quarters-desktop"
  }, [_c('table', {
    staticClass: "table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', _vm._l((_vm.associations), function(assoc, index) {
    return _c('tr', {
      key: assoc.key
    }, [_c('td', [_c('router-link', {
      staticClass: "has-text-info",
      attrs: {
        "to": '/associations/' + assoc.key
      }
    }, [_vm._v(_vm._s(assoc.Name))])], 1), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "is-pulled-right",
      domProps: {
        "innerHTML": _vm._s(_vm.getStatus(assoc.Status))
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30px"
      }
    }, [_c('div', {
      staticClass: "is-pulled-right"
    }, [_c('div', {
      ref: 'associationRow' + index,
      refInFor: true,
      staticClass: "dropdown"
    }, [_c('div', {
      staticClass: "dropdown-trigger"
    }, [_c('div', {
      directives: [{
        name: "on-clickaway",
        rawName: "v-on-clickaway",
        value: (_vm.away),
        expression: "away"
      }],
      staticClass: "icon is-small fa-button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.toggleActive('associationRow' + index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ellipsis-v"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu",
      attrs: {
        "id": "dropdown-menu3",
        "role": "menu"
      }
    }, [_c('div', {
      staticClass: "dropdown-content"
    }, [_c('a', {
      staticClass: "dropdown-item",
      on: {
        "click": function($event) {
          _vm.openCopyModal(index)
        }
      }
    }, [_vm._v("\n                            Cppy Association\n                          ")]), _vm._v(" "), _c('a', {
      staticClass: "dropdown-item",
      on: {
        "click": function($event) {
          _vm.openDeleteModal(index)
        }
      }
    }, [_vm._v("\n                            Delete Association\n                          ")])])])])])])])
  }))])])])])]) : _vm._e(), _vm._v(" "), (_vm.showDeleteModal) ? _c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.showDeleteModal
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        _vm.showDeleteModal = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('h5', [_vm._v("Enter DELETE below to permanently delete " + _vm._s(_vm.associations[_vm.deleteIndex].Name) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "field",
    staticStyle: {
      "margin": "-20px 0px 30px 0px"
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deleteText),
      expression: "deleteText"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter DELETE"
    },
    domProps: {
      "value": (_vm.deleteText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.deleteText = $event.target.value
      }, function($event) {
        _vm.checkDeleteText(_vm.deleteText)
      }]
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "button is-success",
    attrs: {
      "disabled": _vm.disableDeleteContinue
    },
    on: {
      "click": function($event) {
        _vm.deleteAssociation(_vm.deleteIndex)
      }
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.showDeleteModal = false
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e(), _vm._v(" "), (_vm.showCopyModal) ? _c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.showCopyModal
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        _vm.showCopyModal = false
      }
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("New Association Name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copyData.newAssociationName),
      expression: "copyData.newAssociationName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "New Association Name"
    },
    domProps: {
      "value": (_vm.copyData.newAssociationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.copyData, "newAssociationName", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button is-success",
    on: {
      "click": function($event) {
        _vm.copyAssociation(_vm.copyIndex, _vm.copyData.newAssociationName)
      }
    }
  }, [_vm._v("Copy")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.showCopyModal = false
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3e2adc4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/associations/AssociationsList.vue
// module id = vcQr
// module chunks = 1